// A Scenario captures all the inputs to the simulation that aren't city specific
// Business as usual: If NO changes are made at all
export const bauScenario = {
  electrificationVehicleGoal: {
    privateVehicle: 30,
    publicAndCommercial: 60,
  },

  hasRenewableEnergyTarget: false,
  key: 'bau',
  modalSplitIntensity: {
    nonMotorizedTransit: 0, // between 0, 1, 2 ,3, 4
    publicTransit: 0,
    sharedMobility: 0,
  },
}

export const primaryScenario = {
  electrificationVehicleGoal: {
    privateVehicle: 30,
    publicAndCommercial: 60,
  },

  hasRenewableEnergyTarget: false,
  key: 'primary',
  modalSplitIntensity: {
    nonMotorizedTransit: 1, // between 0, 1, 2 ,3, 4
    publicTransit: 3,
    sharedMobility: 2,
  },
}

export const secondaryScenario = {
  electrificationVehicleGoal: {
    privateVehicle: 30,
    publicAndCommercial: 60,
  },

  hasRenewableEnergyTarget: false,
  key: 'secondary',
  modalSplitIntensity: {
    nonMotorizedTransit: 1, // between 0, 1, 2 ,3, 4
    publicTransit: 3,
    sharedMobility: 2,
  },
}



// WEBPACK FOOTER //
// ./src/data/scenarios.ts